<form class="form-horizontal form-material" [formGroup]="registerForm" (ngSubmit)="onSubmit()" #formDir="ngForm">
    
    <div *ngIf="!isVerificationSuccess">
        <!-- Email -->
        <div class="form-group" [ngClass]="{'has-danger': invalidEmail || emailDuplicated}">
            <label class="font-l1">Email</label>
            <input class="form-control" type="email" placeholder="Email" formControlName="email" autocomplete="new-password" (blur)="onCheckEmail()">
            <div class="form-control-feedback" *ngIf="invalidEmail">
                <small *ngIf="email.errors?.email">
                    Email inválido
                </small>
                <small *ngIf="email.errors?.required">
                    El email es requerido
                </small>
            </div>
            <div *ngIf="!invalidEmail && emailDuplicated" class="form-control-feedback">
                <small>
                    El email ya está vinculado a una cuenta
                </small>
            </div>
        </div>

        <!-- button verify sms -->
        <div class="form-group m-t-24 text-center">
            <button class="btn btn-primary w-100" type="button" [disabled]="isInvalid()" (click)="onVerifyEmail()">
                Continuar
            </button>
        </div>
    </div>

    <!-- El código de confirmación fue enviado y hay que verificarlo -->
    <div *ngIf="isVerificationSuccess">

        <div class="text-muted text-left font-c1 p-b-16">
            Enviado a:
            <b>{{email.value}}</b>
        </div>

        <app-code-input [formGroup]="registerForm" [onReset]="onReset"></app-code-input>
        <div *ngIf="codeAlert" class="has-danger">
            <small class="form-control-feedback text-primary">
                {{codeAlert}}
            </small>
        </div>

        <div class="m-t-24 text-center">
            <div class="text-muted font-b2">¿No recibiste el código por email?</div>
            <div class="m-t-10">
                <a class="font-b2 text-purple" href="javascript:void(0)" (click)="onVerifyEmail(true)">Volver a enviar</a>
            </div>
        </div>

        <!-- button submit crear cuenta -->
        <div class="form-group m-t-24 text-center">
            <button class="btn btn-primary btn-med w-100" type="submit" [disabled]="isInvalidCode()">Validar</button>
        </div>
    </div>
</form>